export const SEARCH_SPACES_PATH = '/user/search';
export const SEARCH_TUTORS_PATH = '/user/tutors';
export const TUTOR_SEARCH_ONLINE_PATH = `${SEARCH_TUTORS_PATH}/online`;
export const TUTOR_SEARCH_OFFLINE_PATH = `${SEARCH_TUTORS_PATH}/offline`;

export function tutorListingPath(tutorId: string): string {
  return `${SEARCH_TUTORS_PATH}/${tutorId}`;
}

export function isTutorSearchPath(pathname: string): boolean {
  return (
    pathname === SEARCH_TUTORS_PATH ||
    pathname === TUTOR_SEARCH_ONLINE_PATH ||
    pathname === TUTOR_SEARCH_OFFLINE_PATH
  );
}

export function isTutorListingPath(pathname: string): boolean {
  if (!pathname.startsWith(`${SEARCH_TUTORS_PATH}/`)) {
    return false;
  }
  return pathname !== TUTOR_SEARCH_ONLINE_PATH && pathname !== TUTOR_SEARCH_OFFLINE_PATH;
}

export function isSpaceSearchPath(pathname: string): boolean {
  return pathname.startsWith(SEARCH_SPACES_PATH);
}

export function citySegmentFromSearchPath(pathname: string): string | null {
  if (!isSpaceSearchPath(pathname)) {
    return null;
  }
  const segments = pathname.split('/');
  const searchIndex = segments.indexOf('search');
  const segment = searchIndex >= 0 ? segments[searchIndex + 1] : undefined;
  return segment ?? null;
}
